import { endpoints } from "../config/endpoints";
import axiosConfig from "../utils/axiosConfig";
import objToSearchParam from "../utils/objToSearchParam";
// import { api_Secret, api_key } from "../config/appSettings";
import storeInit from "../redux/store";
import { objToParamsContinuation } from "../utils/funcs";

export const fetchAllBanks = async () => {
    const res = await axiosConfig(endpoints.fetchAllBanks, "get");
    const data = res.data;
    return data;
};

export const fetchEmploymentStatus = async () => {
    const res = await axiosConfig(endpoints.fetchEmploymentStatus, "get");  
    const data = res.data;
    return data;
};

export const fetchFinancier = async () => {
    const res = await axiosConfig(endpoints.fetchFinancier, "get");  
    const data = res.data;
    return data;
};

export const submitCustomerDetails = async (payload) => {
    const res = await axiosConfig(endpoints.submitCustomerDetails, "post", payload); 
    const data = res.data;
    return data; 
}; 

export const sendOtp = async (msisdn, preCustomerId) => {
    const res = await axiosConfig(`${endpoints.sendOTP}?msisdn=${msisdn}&preCustomerId=${preCustomerId}`, "post");  
    const data = res.data;
    return data;
};

export const sendNokOtp = async (payload) => {
    const res = await axiosConfig(`${endpoints.sendNOKOTP}?msisdn=${payload?.msisdn}&preCustomerId=${payload?.preCustomerId}`, "post");  
    const data = res.data;
    return data;
};

export const validateOtp = async (otp, msisdn, preCustomerId) => {
    const res = await axiosConfig(`${endpoints.validateOTP}?otp=${otp}&msisdn=${msisdn}&preCustomerId=${preCustomerId}`, "post"); 
    const data = res.data;
    return data; 
};

export const validateNokOtp = async (otp, msisdn, precustomerId) => {
    const res = await axiosConfig(`${endpoints.validateNOKOTP}?otp=${otp}&msisdn=${msisdn}&preCustomerId=${precustomerId}`, "post"); 
    const data = res.data;
    return data; 
};

export const checkEligibility = async (payload) => {
    const res = await axiosConfig(endpoints.checkEligibility, "post", payload); 
    const data = res.data;
    return data; 
};

export const bookLoan = async (payload) => {
    const res = await axiosConfig(endpoints.bookLoan, "post", payload); 
    const data = res.data;
    return data; 
};

export const oxygenOTP = async (msisdn) => {
    const res = await axiosConfig(`${endpoints.oxygenOtp}?msisdn=${msisdn}`, "post"); 
    const data = res.data;
    return data; 
};

export const loanApproval = async (payload) => {
    const res = await axiosConfig(endpoints.loanApproval, "post", payload);  
    const data = res.data;
    return data;
};

export const loanActivation = async (payload) => {
    const res = await axiosConfig(endpoints.loanActivation, "post", payload);  
    const data = res.data;
    return data;
};

export const fetchPrecustomerByMsisdn = async (msisdn) => {
    const res = await axiosConfig(`${endpoints.fetchPrecustomerByMsisdn}?msisdn=${msisdn}`, "get"); 
    const data = res.data;
    return data; 
};

export const fetchPrecustomerByMsisdnAndEmail = async (payload) => {
    const res = await axiosConfig(`${endpoints.fetchPrecustomerByMsisdnAndEmail}?msisdn=${payload?.msisdn}&email=${payload?.email}&partnerId=${payload?.partnerId}`, "get"); 
    const data = res.data;
    return data; 
};


export const fetchRepaymentSetupLink = async (preCustomerId) => {
    const res = await axiosConfig(`${endpoints.fetchRepaymentSetupLink}?preCustomerId=${preCustomerId}`, "get"); 
    const data = res.data;
    return data; 
};

export const confirmOxygenPayment = async (payload) => {
    const res = await axiosConfig(endpoints.verifyOxygenPayment, "post", payload);  
    const data = res.data;
    return data;
};

export const verifyBundleActivation = async (msisdn) => {
    const res = await axiosConfig(`${endpoints.verifyActivateBundle}?msisdn=${msisdn}`, "get");  
    const data = res.data;
    return data;
};

export const OxygenManualReviewDecision = async (payload) => {
    const res = await axiosConfig(endpoints.manualReviewDecision, "post", payload);  
    const data = res.data;
    return data;
};

export const fetchAllDevices = async (params) => {
    const res = await axiosConfig(`${endpoints.fetchAllDevices}${objToSearchParam(params)}`, "get");
    const resData = res.data;
    return resData;
};

export const fetchDeviceByCreditLimit = async (amount, params) => {
    const res = await axiosConfig(`${endpoints.deviceByCreditLimit}?amount=${amount}${objToParamsContinuation(params)}`, "get");
    const resData = res.data;
    return resData;
};

export const fetchFBNDeviceByTenure = async (payload, params) => {

  const res = await axiosConfig(
    `${endpoints.fetchDeviceByTenure}${objToSearchParam(params)}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fbnFetchMoreDevices = async (payload, params) => {

  const res = await axiosConfig(
    `${endpoints.fbnFetchMoreDevices}${objToSearchParam(params)}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};


export const fetchBundleByDeviceId = async (payload) => {
  const res = await axiosConfig(endpoints.fetchBundleByDeviceId, "post", payload); 
  const data = res.data;
  return data; 
};

export const fetchBundleByDevicePrice = async (payload) => {
  const res = await axiosConfig(endpoints.fetchBundleByDevicePrice, "post", payload); 
  const data = res.data;
  return data; 
};

export const submitCustomerBundle = async (payload) => {
  const res = await axiosConfig(endpoints.submitCustomerBundle, "post", payload); 
  const data = res.data;
  return data; 
};

export const checkDeviceExistance = async (payload) => {
  const res = await axiosConfig(endpoints.checkDeviceExistance, "post", payload);  
  const data = res.data;
  return data;
};

export const paymentSchedulePlans = async (payload) => {
  const token =
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      source: "web",
      api_key: 1,
      api_Secret: 1,
    },
  };

  const res = await axiosConfig(
    `${endpoints.paymentSchedulePlan}`,
    "post",
    JSON.stringify(payload),
    config
  );
  const resData = res.data;

  return resData;
};


export const submitAODF2CustomerDetails = async (payload) => {
    const res = await axiosConfig(endpoints.submitAODF2CustomerDetails, "post", payload); 
    const data = res.data;
    return data; 
};

export const sendAODF2OTP = async (payload) => {
    const res = await axiosConfig(endpoints.sendAODF2OTP, "post", payload); 
    const data = res.data;
    return data; 
};

export const validateAODF2OTP = async (payload) => {
    const res = await axiosConfig(endpoints.validateAODF2OTP, "post", payload); 
    const data = res.data;
    return data; 
};

export const sendAODF2NOKOTP = async (payload) => {
    const res = await axiosConfig(endpoints.sendAODF2NOKOTP, "post", payload); 
    const data = res.data;
    return data; 
};

export const validateAODF2NOKOTP = async (payload) => {
    const res = await axiosConfig(endpoints.validateAODF2NOKOTP, "post", payload); 
    const data = res.data;
    return data; 
};

export const fetchAODF2BundlesByDeviceId = async (payload) => {
  const res = await axiosConfig(endpoints.fetchAODF2BundlesByDeviceId, "post", payload); 
  const data = res.data;
  return data; 
};

export const submitAODF2CustomerBundle = async (payload) => {
  const res = await axiosConfig(endpoints.submitAODF2CustomerBundle, "post", payload); 
  const data = res.data;
  return data; 
};

export const fbnDownPaymentLink = async (preCustomerId) => {
    const res = await axiosConfig(`${endpoints.fbnDownPaymentLink}?preCustomerId=${preCustomerId}`, "post");  
    const data = res.data;
    return data;
};

export const fbnVerifyDownPayment = async (preCustomerId) => {
    const res = await axiosConfig(`${endpoints.fbnVerifyDownPayment}?preCustomerId=${preCustomerId}`, "post");  
    const data = res.data;
    return data;
};

export const createNewPrecustomer = async (payload) => {
    const res = await axiosConfig(`${endpoints.createNewPrecustomer}?msisdn=${payload.msisdn}&partner_id=${payload.partnerId}`, "post");  
    const data = res.data;
    return data;
};

export const oxygenFirstCustomerDetails = async (payload) => {
  const res = await axiosConfig(endpoints.oxygenFirstCustomerDetails, "post", payload); 
  const data = res.data;
  return data; 
};

export const oxygenEligibilityResponse = async (preCustomerId) => {
    const res = await axiosConfig(`${endpoints.oxygenEligibilityResponse}?id=${preCustomerId}`, "post");  
    const data = res.data;
    return data;
};

export const oxygenSecondCustomerDetails = async (payload) => {
  const res = await axiosConfig(endpoints.oxygenSecondCustomerDetails, "post", payload); 
  const data = res.data;
  return data; 
};


